import { isNullOrEmpty } from "common/strings";
import Commodity from "./commodity";
import PositionGroup from "./positionGroup";

export interface LocationBase {
  id: string | null;
  name: string | null;
}

export default interface PhysicalLocation extends LocationBase {
  postalCode: string | null;
  grainAccountingId: string | null;
  fcmLocationId: string | null;
  homeLocation: LocationBase | null;
  bidGroup: string | null;
  marketZone: string | null;
  positionGroup: PositionGroup | null;
  commodities: Commodity[] | null;
  isDefaultBuyLocation: boolean;
  isInternalOnly: boolean;
  isContractLocation: boolean;
  isInventoryLocation: boolean;
  isDeliveryLocation: boolean;
  displayInBidEditor: boolean;
  tags?: Nullish<Record<string, string>>;
}

export const defaultPhysicalLocation: PhysicalLocation = {
  id: null,
  name: null,
  postalCode: null,
  grainAccountingId: null,
  fcmLocationId: null,
  homeLocation: null,
  bidGroup: null,
  marketZone: null,
  positionGroup: null,
  commodities: null,
  isDefaultBuyLocation: false,
  isInternalOnly: false,
  isContractLocation: true,
  isInventoryLocation: true,
  isDeliveryLocation: true,
  displayInBidEditor: true,
  tags: null
};

export function isSelfOrChild(location: PhysicalLocation, id: string): boolean {
  return id === AllRegionsHomeLocation.id || location.homeLocation?.id === id || location.id === id;
}

export const AllRegionsHomeLocation: LocationBase = {
  id: 'ALL',
  name: 'All Regions'
};

export const DetermineLaterLocation: LocationBase = {
  id: null,
  name: 'Determine Later'
};

export function getPhysicalLocation(homeLocation: LocationBase): PhysicalLocation {
  const physicalLocation: PhysicalLocation = {
    id: homeLocation.id,
    name: homeLocation.name,
    postalCode: null,
    grainAccountingId: null,
    fcmLocationId: null,
    homeLocation: null,
    bidGroup: null,
    marketZone: null,
    positionGroup: null,
    commodities: null,
    isDefaultBuyLocation: false,
    isInternalOnly: false,
    isContractLocation: true,
    isInventoryLocation: true,
    isDeliveryLocation: true,
    displayInBidEditor: true,
    tags: null
  }
  return physicalLocation;
}

export function getPhysicalLocationDisplayName(location: PhysicalLocation, isCustomer: boolean = false): string | null {
  let displayName: string | null = ""
  if (location != null) {
    displayName = location.name;
    if (!isCustomer && !isNullOrEmpty(location.grainAccountingId))
      displayName += ` - ${location.grainAccountingId}`;
  }
  return displayName;
}

